import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import {
  AccountingTrialBalanceScreen,
  type TrialBalanceSearch,
} from '@/features/accounting/trial-balance-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/trial-balance')({
  validateSearch: (search: Record<string, unknown>): TrialBalanceSearch => ({
    from: typeof search.from === 'string' && search.from !== '' ? search.from : undefined,
    to: typeof search.to === 'string' && search.to !== '' ? search.to : undefined,
    hide_zero: search.hide_zero !== '0' && search.hide_zero !== false,
  }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_report.view')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: AccountingTrialBalanceRoute,
})

function AccountingTrialBalanceRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  return (
    <AccountingTrialBalanceScreen
      search={search}
      onSearchChange={(next) =>
        void navigate({ to: '/accounting/trial-balance', search: next, replace: true })
      }
    />
  )
}
